export default {"src":"/_next/static/media/cutlery.3a964e56.svg","height":20,"width":13,"blurWidth":0,"blurHeight":0};